module.exports = __webpack_public_path__ + "static/img/no_results_01.05e751e5.png";